import axios from 'axios';
export default class ServiceTerms {
    async getServiceTermsList(information_type) {
        return await axios .post('api/v1/admin/information/list', { information_type: information_type });
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_date,
    //         })
    //         .then((res) => res);
    // }
    async viewService(update_key) {
        return await axios
            .post(`api/v1/admin/information/details`, {
                update_key: update_key,
            })
            .then((res) => res.data.result);
    }
    async editService(data) {
        return await axios
            .post(`api/v1/admin/information/edit`,data)
            .then((res) => res);
    }
}
